export default __webpack_public_path__ + "assets/logos/6a07561746cda3430ff956614b6ff63b.png";